import { fetchUtils } from 'react-admin'
import { stringify } from 'query-string'
import { getJWT } from '../helper/localStore/getJWT'
import { HttpError } from 'react-admin'
import { objectToQueryString } from 'src/helper/objectToQueryString'
import { compressImage } from 'src/helper/CompressImage'
import { generateRandomString } from 'src/helper/generateRandomString'
import { routeConfigServices } from 'src/services/reservation/route-config/routeConfig.service'
import { workUnitPaymentServices } from 'src/services/payment/workUnit/WorkUnit.service'
const httpClient = fetchUtils.fetchJson

export default {
  getList: async (resource, params) => {
    if (resource === 'route-config') {
      try {
        const response = await routeConfigServices.getRoutes(params?.filter)
        const data = Array.isArray(response?.data) ? response.data : []
        
        // Enriquecer datos con work_unit_name
        if (data.length > 0) {
          try {
            const workUnits = await workUnitPaymentServices.getByAll()
            const workUnitMap = workUnits.reduce((acc, wu) => {
              acc[wu.token] = wu.long_name
              return acc
            }, {})
            
            data.forEach(item => {
              item.work_unit_name = workUnitMap[item.work_unit_token] || item.work_unit_token
            })
          } catch (error) {
            console.error('Error fetching work units:', error)
          }
        }
        
        // Ordenamiento de listas
        const { page, perPage } = params.pagination || { page: 1, perPage: data.length || 25 }
        const { field, order } = params.sort || { field: 'id', order: 'ASC' }

        const getComparable = (val) => {
          if (val === null || val === undefined) return ''
          if (typeof val === 'number') return val
          const n = Number(val)
          if (!isNaN(n)) return n
          const d = new Date(val)
          if (!isNaN(d.getTime())) return d.getTime()
          return String(val).toLowerCase()
        }

        const sorted = [...data].sort((a, b) => {
          const av = getComparable(a?.[field])
          const bv = getComparable(b?.[field])
          if (av < bv) return order === 'ASC' ? -1 : 1
          if (av > bv) return order === 'ASC' ? 1 : -1
          return 0
        })

        const start = (page - 1) * perPage
        const paged = sorted.slice(start, start + perPage)

        const total = response?.total ?? data.length
        const parsedTotal = Number(total)
        return {
          data: paged,
          total: Number.isNaN(parsedTotal) ? data.length : parsedTotal,
        }
      } catch (error) {
        return {
          data: [],
          total: 0,
          pageInfo: 'ra.notification.data_provider_error',
        }
      }
    }

    const { page, perPage } = params.pagination
    const { field, order } = params.sort

    const formatOrder = (order) => {
      if (order === 'DESC') return '-'
      if (order === 'ASC') return '+'
      return '+'
    }

    const query = {
      limit: JSON.stringify(perPage),
      skip: (page - 1) * perPage,
    }

    // hasta que se normalice la libreria que se usa para filtrar
    // agregamos esta diferencia dependiendo el resource
    if (
      resource === 'reservation' ||
      resource === 'business-unit' ||
      resource === 'due-date-method' ||
      resource === 'supplier-billing' ||
      resource === 'due-date-range' ||
      resource === 'supplier-payment-order' ||
      resource === 'item-supplier' ||
      resource === 'bases'
    ) {
      if(resource === 'item-supplier' && field === 'supplier_name'){
        query['order'] = `${formatOrder(order)}${field}`
      } else{
        query['order_by'] = `${formatOrder(order)}${field}`
      }
    } else {
      query['ordering'] = `${field}.${order}`
    }
    const addFilters = (filter) => {
      if (filter && Object.keys(filter).length > 0) {
        return '&' + objectToQueryString(filter)
      }
      return ''
    }

    // hasta que se normalice la libreria que se usa para filtrar
    // agregamos esta diferencia en la URL dependiendo el resource
    if (resource === 'business-unit') {
      resource = 'business-unit/new-filter'
    }
    const url = `${process.env.REACT_APP_URL_RESERVATION}/${resource}/?${stringify(query)}${addFilters(
      params.filter
    )}`
    try {
      const response = await fetch(url, { headers: { 'authentication-token': getJWT() } })

      const { status } = response
      const total = response.headers.get('row-counter')
      const jsonData = await response.json()
      if (status === 401) {
        return Promise.reject(new HttpError(jsonData && jsonData.detail, status, jsonData))
      }
      if (status === 403) {
        return Promise.reject(new HttpError(jsonData && jsonData.detail, status, jsonData))
      }
      if (!Array.isArray(jsonData)) {
        return {
          data: [],
          total: 0,
          pageInfo: 'ra.notification.data_provider_error',
        }
      }

      return {
        data: jsonData,
        total: parseInt(total || jsonData.length),
      }
    } catch (error) {
      localStorage.removeItem(`RaStore.reservation.listParams`)
      return {
        data: [],
        total: 0,
        pageInfo: 'ra.notification.data_provider_error',
      }
    }
  },

  getOne: (resource, params) =>
    httpClient(`${process.env.REACT_APP_URL_RESERVATION}/${resource}/${params.id}`, {
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({
      data: json,
    })),

  update: (resource, params) => {
    if (resource === 'business-unit') {
      return logoUseCase(resource, params, 'businessUnitStr', true)
    }
    if (resource === 'work-unit') {
      return logoUseCase(resource, params, 'workUnitStr', true)
    }

    return httpClient(`${process.env.REACT_APP_URL_RESERVATION}/${resource}/${params.id}`, {
      method: 'PUT',
      body: JSON.stringify(params.data),
      headers: new Headers({ 'authentication-token': getJWT() }),
    })
      .then(({ json }) => ({ data: json }))
      .catch((error) => {
        console.error(error)
        return Promise.reject(error)
      })
  },

  create: async (resource, params) => {
    if (resource === 'business-unit') {
      return await logoUseCase(resource, params, 'businessUnitStr')
    }
    if (resource === 'work-unit') {
      return await logoUseCase(resource, params, 'workUnitStr')
    }

    return httpClient(`${process.env.REACT_APP_URL_RESERVATION}/${resource}/`, {
      method: 'POST',
      body: JSON.stringify(params.data),
      headers: new Headers({ 'authentication-token': getJWT() }),
    })
      .then(({ json }) => ({
        data: { ...params.data, id: json.id },
      }))
      .catch((error) => {
        console.error(error)
        return Promise.reject(error)
      })
  },

  getMany: (resource, params) => {
    return httpClient(
      `${process.env.REACT_APP_URL_RESERVATION}/${resource}/?operator=or&id=${Object.values(
        params.ids
      ).toString()}`,
      {
        headers: new Headers({ 'authentication-token': getJWT() }),
      }
    ).then(({ json }) => {
      return { data: json }
    })
  },

  delete: (resource, params) => {
    return httpClient(`${process.env.REACT_APP_URL_RESERVATION}/${resource}/${params.id}`, {
      method: 'DELETE',
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({ data: json }))
  },

  deleteMany: (resource, params) => {
    const list_id = params.ids
    return httpClient(`${process.env.REACT_APP_URL_RESERVATION}/${resource}/many/`, {
      body: JSON.stringify(list_id),
      method: 'DELETE',
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then((data) => {
      console.log(data)
      // /many/ de reservas deveulve null, entonces tengo que devolver los IDs que se supone fueron eliminados para que el dataprovider no falle
      if (data.status == 200) {
        return { data: list_id }
      }
    })
  },

  addUser: (hash_user) => {
    httpClient(`${process.env.REACT_APP_URL_RESERVATION}/user/assignUser`, {
      method: 'POST',
      body: JSON.stringify({ hash_user: hash_user }),
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({ data: json }))
  },
}

const logoUseCase = async (resource, params, name, isEditMode = false) => {
  let formData = new FormData()

  // "name" is the name of the key that represents the resource. ex:  workUnitStr
  formData.append(name, JSON.stringify(params.data))

  if (params.data.logo && params.data.logo.rawFile) {
    const fieldName = 'logo'
    const compressImageLogoBlob = await compressImage(params.data.logo.rawFile, fieldName)
    const randomSting = generateRandomString(9)
    if (compressImageLogoBlob){
      const compressedFileLogo = new File([compressImageLogoBlob], `${randomSting}_${params.data.logo.rawFile.name}`, {
        type: compressImageLogoBlob.type,
        lastModified: params.data.logo.rawFile?.lastModified || new Date()
      });
      formData.append(fieldName, compressedFileLogo);
    }
  }

  if (params.data.logo_voucher && params.data.logo_voucher.rawFile) {
    const fieldName = 'logo_voucher'
    const compressImageLogoVoucherBlob = await compressImage(params.data.logo_voucher.rawFile, fieldName)
    if (compressImageLogoVoucherBlob){
      const randomSting = generateRandomString(9)
      const compressedFileLogo = new File([compressImageLogoVoucherBlob], `${randomSting}_${params.data.logo_voucher.rawFile.name}`, {
        type: compressImageLogoVoucherBlob.type,
        lastModified: params.data.logo_voucher.rawFile?.lastModified || new Date()
      });
      formData.append(fieldName, compressedFileLogo);
    }
  }

  let URL = `${process.env.REACT_APP_URL_RESERVATION}/${resource}/`
  let METHOD = 'POST'
  if (isEditMode) {
    URL = `${process.env.REACT_APP_URL_RESERVATION}/${resource}/${params.id}`
    METHOD = 'PUT'
  }

  return httpClient(URL, {
    method: METHOD,
    body: formData,
    headers: new Headers({ 'authentication-token': getJWT() }),
  })
    .then(({ json }) => ({
      data: { ...params.data, id: json.id },
    }))
    .catch((error) => {
      console.error(error)
      return Promise.reject(error)
    })
}
